import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Twyla extends Lit3formBlock {
  static get characterName() {
    return 'twyla';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid twyla-layout">
          ${this.firstImage
            ? html`
                <figure class="first-figure">
                  <img src="${this.imageUrl(this.firstImage)}" />
                  <figcaption>
                    ${this.figCaptionHTML(this.firstImage)}
                  </figcaption>
                </figure>
              `
            : html``}

          <div class="header-wrapper">
            <h2>${unsafeHTML(this.headingStr)}</h2>
            <div class="cta-wrapper">
              <cta-text
                cta-data=${this.ctaData()}
                .ctaAnalyticsData=${analyticsCtaDataObject(
                  this.ctaData(),
                  this.headingStr
                )}
              ></cta-text>
            </div>
          </div>
          <div class="paragraphs-wrapper">
            ${this.textSections.map(paragraph => {
              return html`
                <p class="paragraph">
                  ${unsafeHTML(this.withLineBreaks(paragraph))}
                </p>
              `;
            })}
          </div>
          ${this.secondImage
            ? html`
                <figure class="second-figure">
                  <img src="${this.imageUrl(this.secondImage)}" />
                  <figcaption>
                    ${this.figCaptionHTML(this.secondImage)}
                  </figcaption>
                </figure>
              `
            : html``}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageUrl(img) {
    return this.imagebossUrl(img.src, 500, null);
  }

  ctaData(image) {
    let cta;
    if (image) {
      cta = image.cta;
      cta.notBold = true;
    } else {
      cta = this.content.cta;
    }
    return JSON.stringify(cta);
  }

  imageDescription(img) {
    return img.description || '';
  }

  get headingStr() {
    return this.withLineBreaks(this.content.heading) || '';
  }

  get imagesArr() {
    if (!this.content.images || this.content.images.length === 0) {
      return [];
    }
    return this.content.images;
  }

  get firstImage() {
    if (!this.imagesArr.length) return null;
    return this.imagesArr[0][1];
  }

  get secondImage() {
    if (!this.imagesArr.length) return null;
    return this.imagesArr[1][1];
  }

  get textSections() {
    if (
      !this.content.text_sections?.length ||
      !this.content.text_sections[0]?.paragraphs?.length
    ) {
      return [];
    }
    return this.content.text_sections[0].paragraphs;
  }

  figCaptionHTML(image) {
    return html`
      <div class="image-caption">
        <span>
          <p>
            ${unsafeHTML(image.description || '')}
          </p>
        </span>
        <span>
          <a href=${image.full_resolution_src} target="_blank" download>
            <span id="download-icon">
              <img src="/static/icons/SVG/download-12x16.svg" />
            </span>
          </a>
        </span>
      </div>
    `;
  }
}
Twyla.defineElement();
